module.exports = __webpack_public_path__ + "media/images/candidate-assessments-dd359b518dcd878fdef0b4463c6fdaa4.svg";